<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Location" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Location</h4>
                    </div>
                    <vs-button
                        color="primary"
                        class="btn mb-4 md:mb-0 mr-1"
                        @click="submitForm"
                        v-show="editMode"
                    >Save</vs-button>
                    <vs-button
                        color="primary"
                        class="btn mb-4 md:mb-0 mr-1"
                        @click="editMode = true"
                        v-show="!editMode"
                    >Edit</vs-button>
                </div>
                <div class="vx-row mt-6" v-if="data">
                    <div class="vx-col md:w-1/4 w-full">
                        <!-- <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    disabled
                                    label="Location ID "
                                    v-model="data.id"
                                />
                                <vs-input class="w-full" label="Location *" v-model="data.location" :disabled="editMode ? false : true"/>
                            </div>
                        </div> -->
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    label="Location Code *"
                                    v-model="data.location_code"
                                    :disabled="editMode ? false : true"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Location Type *</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.location_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, location_type)"
                                    :disabled="editMode ? false : true"
                                >
                                    <vs-select-item v-for="(item, index) in location_type.data" :key="index" :value="item.id" :text="item.code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Dedicated Product *</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.dedicated_product_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, product)"
                                    :disabled="editMode ? false : true"
                                >
                                    <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Client *</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="editMode ? false : true"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Section *</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.section_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, section)"
                                    :disabled="editMode ? false : true"
                                >
                                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <br />
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <b>Blocking</b>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-checkbox
                                    v-model="data.pick_block"
                                    :disabled="editMode ? false : true"
                                >Pick Block</vs-checkbox>
                                <!-- <vs-radio v-model.number="data.pick_block" vs-name="pick_block" vs-value="1">Pick Block</vs-radio> -->
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-checkbox
                                    v-model="data.put_block"
                                    :disabled="editMode ? false : true"
                                >Put Block</vs-checkbox>
                                <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                            </div>
                        </div>

                        <br />
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <b>Config</b>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-checkbox
                                    v-model="data.cool_room"
                                    :disabled="editMode ? false : true"
                                >Cool Room</vs-checkbox>
                                <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    label="Location Sequence "
                                    v-model="data.location_squence"
                                    :disabled="editMode ? false : true"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    label="Cap. Volume"
                                    v-model="data.cap_volume"
                                    :disabled="editMode ? false : true"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    label="Cap. Weight "
                                    v-model="data.cap_weight"
                                    :disabled="editMode ? false : true"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-input
                                    class="w-full"
                                    label="Cap. Storage Unit"
                                    v-model="data.cap_storage_unit"
                                    :disabled="editMode ? false : true"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Warehouse *</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, warehouse)"
                                    :disabled="editMode ? false : true"
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <!-- <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Section *</label>
                                <vs-select :options="warehouseOptions" v-model="data.warehouse_id" :reduce="warehouse_id => warehouse_id.id"></vs-select>
                            </div>
                        </div>-->
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: null,
            locationTypeOptions: [],
            clientOptions: [],
            sectionOptions: [],
            warehouseOptions: [],
            editMode: false,
            location_type: {
                data: [],
                loading: false,
                endpoint: 'master/locationtypes',
                objectKey: 'code'
            },
            product: {
                data: [],
                loading: false,
                endpoint: 'master/product',
                objectKey: 'product_code'
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            section: {
                data: [],
                loading: false,
                endpoint: 'master/sections',
                objectKey: 'section_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        fetchData() {
            this.isLoading = true;
            this.$http
                .get("master/locations/" + this.$route.params.id)
                .then(location => {
                    this.data = location.data;
                    this.data.warehouse_id = this.data.warehouses_id
                    this.location_type.data.push({
                        id: location.data.location_type_id,
                        code: location.data.name
                    })

                    this.client.data.push({
                        id: location.data.client_id,
                        client_code: location.data.client_code
                    })

                    if(location.data.dedicated_product_id) {
                        this.product.data.push({
                            id: location.data.dedicated_product_id,
                            product_code: location.data.product_code
                        })
                    }

                    this.section.data.push({
                        id: location.data.section_id,
                        section_code: location.data.section_code
                    })

                    this.warehouse.data.push({
                        id: location.data.warehouses_id,
                        warehouses_code: location.data.warehouses_code
                    })

                    this.data.put_block =
                        this.data.put_block == 0 ? false : true;
                    this.data.pick_block =
                        this.data.pick_block == 0 ? false : true;
                        this.isLoading = false;

                    this.data.cool_room =
                        this.data.cool_room == 0 ? false : true;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.fetchData();
                        },
                        cancel: () => this.$router.push({name: 'master-location'}),
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                });
        },
        submitForm() {
            this.isLoading = true;

            this.data.put_block = this.data.put_block == true ? 1 : 0;
            this.data.pick_block = this.data.pick_block == true ? 1 : 0;
            this.data.cool_room = this.data.cool_room == true ? 1 : 0;

            this.$http
                .put(
                    "master/locations/" + this.$route.params.id + "/update",
                    this.data
                )
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: "success",
                        title: "Saved Successfully",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Location updated successfully"
                    });
                    this.$router.push({ path: "/master/location" });
                })
                .catch(error => this.handleError(error));
        },
        back() {
            if (this.editMode) {
                this.$vs.dialog({
                    color: "warning",
                    title: "Leave Page",
                    text: "Changes you made may not be saved?",
                    acceptText: "Leave Page",
                    accept: () => {
                        this.$router.push({name: 'master-location'});
                    }
                });
            } else {
                this.$router.push({name: 'master-location'});
            }
        },
    },
    mounted() {
        this.fetchData();
    }
};
</script>
